import dJSON from 'dirty-json';

const moduleSelector = '.industries__content';

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const data = dJSON.parse(query.data);
      const cleanedData = data.data;

      cleanedData.forEach((item) => {
        const box = document.createElement('div');
        box.classList.add('industries__box', 'nRel');
        box.innerHTML = `
          <div class="industries__box__icon">
            <img src="${item.icon}" alt="" width="35" height="35"/>
          </div>
          <div class="industries__box__content">
            <h3>${item.title}</h3>
          </div>
          <a href="${item.link}" class="nLinkArea"></a>
        `;

        query.appendChild(box);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
